"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiProfileRepRatesState } from "@/entities/IProfile";
import UserPageRepNewRepSearch from "./UserPageRepNewRepSearch";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageRepNewRep(t0) {
  const $ = _c(7);
  const {
    profile,
    repRates,
    onSuccess,
    onCancel
  } = t0;
  let t1;
  if ($[0] !== onSuccess) {
    t1 = onSuccess ? {
      onSuccess
    } : {};
    $[0] = onSuccess;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const searchProps = t1;
  let t2;
  if ($[2] !== onCancel || $[3] !== profile || $[4] !== repRates || $[5] !== searchProps) {
    t2 = <UserPageRepNewRepSearch repRates={repRates} profile={profile} onCancel={onCancel} {...searchProps} />;
    $[2] = onCancel;
    $[3] = profile;
    $[4] = repRates;
    $[5] = searchProps;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}